export default "__VITE_ASSET__Dywi9MgJ__"